import { render, staticRenderFns } from "./reshycn.vue?vue&type=template&id=0f2afb68&scoped=true&"
import script from "./reshycn.vue?vue&type=script&lang=js&"
export * from "./reshycn.vue?vue&type=script&lang=js&"
import style0 from "./reshycn.vue?vue&type=style&index=0&id=0f2afb68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2afb68",
  null
  
)

export default component.exports